<script setup name="TvbHomeColumns">
import { reactive, inject } from 'vue'
import { getHomeLayout } from './../../../../api/home'
import TvbHomeSmallBanner from './../SmallBanner/index.vue'
import TvbHomeColumnsNews from './../News/index.vue'
import TvbHomeMytvSuper from './../MytvSuper/index.vue'
import TvbHomeMpm from './../Mpm/index.vue'
import TvbHomeEpg from './../Epg/index.vue'

const size = inject('size')

const layout = reactive({
  list: []
})

const componentsMap = {
  1: TvbHomeSmallBanner,
  2: TvbHomeColumnsNews,
  3: TvbHomeColumnsNews,
  4: TvbHomeMytvSuper,
  10: TvbHomeColumnsNews,
  11: TvbHomeMpm,
  12: TvbHomeEpg
}

getHomeLayout().then(({ data }) => {
  layout.list = data.list
})
</script>

<template>
  <div class="tvb-home-columns" :class="[size]">
    <template v-for="(item, index) in layout.list" :key="index">
      <component
        :is="componentsMap[item.type]"
        :info="item"
        :link-target="[2, 3, 4].includes(item.type) ? 2 : 1"
      />
      <tvb-ads
        :ad-type="['s', 'xs'].includes(size) ? 'bn' : 'sb'"
        :key="['s', 'xs'].includes(size) ? 'bn' : 'sb'"
        :position="6"
        :style="{ marginTop: ['s', 'xs'].includes(size) ? '32px' : '56px' }"
        v-if="(index + 1) % 3 === 1"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.tvb-home-columns {
  --tvb-home-columns-margin-top: 56px;

  > * {
    margin-top: var(--tvb-home-columns-margin-top) !important;
    &:first-child {
      margin-top: 0 !important;
    }
  }
  &.s,
  &.xs {
    --tvb-home-columns-margin-top: 32px;
    > * {
      &:first-child {
        margin-top: 12px !important;
      }
    }
  }
}
</style>
